module.exports = __webpack_public_path__ + "static/media/prince-hotel.90a84fcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/ContactUs/prince-hotel.png
// module id = 55
// module chunks = 0